mutation DeleteRatelist($id: ID!) {
  deleteRatelist(id: $id) {
    result
    messages {
      field
      message
      severity
    }
  }
}

mutation CopyRatelist($id: ID!) {
  copyRatelist(ratelistId: $id) {
    result
    messages {
      field
      message
      severity
    }
    payload {
      ...RatelistOverviewItem
    }
  }
}

mutation CreateRate(
  $nodes: [RatelistNodeInput!]!
  $rootNodeId: ID!
  $name: String!
  $description: String
  $concept: Boolean! = false
  $rateType: RatelistType!
  $validFrom: Date!
  $validTo: Date
  $companiesDefault: [ID!]!
  $companies: [ID!]!
) {
  createRatelist(
    companyRatelist: { companies: $companies, companiesDefault: $companiesDefault }
    input: {
      nodes: $nodes
      rootNodeId: $rootNodeId
      name: $name
      description: $description
      concept: $concept
      validFrom: $validFrom
      validTo: $validTo
    }
    type: $rateType
  ) {
    result
    messages {
      field
      message
      severity
    }
    payload {
      id
    }
  }
}

mutation EditRate(
  $erasedNodes: [ID!]!
  $nodes: [RatelistNodeInput!]!
  $ratelistId: ID!
  $name: String!
  $description: String
  $concept: Boolean! = false
  $validFrom: Date
  $validTo: Date
  $companiesDefault: [ID!]!
  $companies: [ID!]!
) {
  editRatelist(
    companyRatelist: { companies: $companies, companiesDefault: $companiesDefault }
    id: $ratelistId
    input: {
      erasedNodes: $erasedNodes
      nodes: $nodes
      name: $name
      description: $description
      concept: $concept
      validFrom: $validFrom
      validTo: $validTo
    }
  ) {
    result
    messages {
      field
      message
      severity
    }
  }
}
